define('common/config/momentLocales',[
    'common/3rdparty/momentlangs/en-gb',
    'common/3rdparty/momentlangs/fi',
    'common/3rdparty/momentlangs/no',
    'common/3rdparty/momentlangs/de',
    'common/3rdparty/momentlangs/sv'
], function() {
});

